import { render } from "./chips-msg-box.vue?vue&type=template&id=204b64b2&scoped=true&ts=true"
import script from "./chips-msg-box.vue?vue&type=script&lang=ts"
export * from "./chips-msg-box.vue?vue&type=script&lang=ts"

import "./chips-msg-box.vue?vue&type=style&index=0&id=204b64b2&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204b64b2"]])

export default __exports__